/**
 * Admin API – all admin panel reads via Cloud Functions.
 * No direct Firestore access. Caller must be admin.
 */

import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase/config';

const functions = getFunctions(app, 'us-central1');

function call(name, data = {}) {
  const fn = httpsCallable(functions, name);
  return fn(data).then((res) => res.data);
}

/**
 * Fetch all admin panel data: users, players, matches, tournaments, registrations, apartments.
 */
export async function getAdminAllData() {
  return call('adminGetAllData', {});
}

/**
 * Create apartment. Admin only.
 */
export async function createApartment(data) {
  return call('adminCreateApartment', { data });
}

/**
 * Update apartment. Admin only.
 */
export async function updateApartment(apartmentId, data) {
  return call('adminUpdateApartment', { apartmentId, data });
}

/**
 * Delete apartment. Admin only.
 */
export async function deleteApartment(apartmentId) {
  return call('adminDeleteApartment', { apartmentId });
}
